import { render, staticRenderFns } from "./config-list.vue?vue&type=template&id=1a62c4fc&scoped=true&"
import script from "./config-list.vue?vue&type=script&lang=js&"
export * from "./config-list.vue?vue&type=script&lang=js&"
import style0 from "./config-list.vue?vue&type=style&index=0&id=1a62c4fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a62c4fc",
  null
  
)

export default component.exports